import axios from "axios";
import Loading from "./Loading";
import FrontRow from "./FrontRow";



class Front extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            item:[],
            itemSection:[],
            loading:true,
        };
    }


    componentDidMount() {

        if (this.props.page === "post") {
            axios.get(`/objects/front/${this.props.page}/`)
                .then(function (res) {
                    const items = res.data;
                    const sale = items.sale
                    const rent = items.rent
                    this.setState({
                        sale:sale,
                        rent: rent,
                        loading: false,
                    });

                }.bind(this))
                .catch(function (error) {
                });

        } else  if (this.props.page === "auction") {
            axios.get(`/objects/front/${this.props.page}/`)
                .then(function (res) {
                    const items = res.data.objects;
                    this.setState({
                        item: items,
                        loading: false,
                    });

                }.bind(this))
                .catch(function (error) {
                });
        }
    }


    render(item = this.state.item, rent=this.state.rent, sale= this.state.sale) {

        let kasvavMets = item[1];
        let kinnistud = item[2];
        let metsamaterjal = item[4];
        let pollumaarent = item[5];
        if(!this.state.loading){
            if(this.props.page === "auction"){
                return (
                    <React.Fragment>
                        <FrontRow auctionType={this.props.auctionType} item={kasvavMets} title={LANG['Kasvav mets'] || 'Kasvav mets'} url={"/index.php?f=oksjonid&t=1"}/>
                        <FrontRow auctionType={this.props.auctionType} item={kinnistud} title={LANG['Kinnistud'] || 'Kinnistud'} url={"/index.php?f=oksjonid&t=2"}/>
                        <FrontRow auctionType={this.props.auctionType} item={metsamaterjal} title={LANG['Metsamaterjal'] || 'Metsamaterjal'} url={"/index.php?f=oksjonid&t=4"}/>
                        <FrontRow auctionType={this.props.auctionType} item={pollumaarent} title={LANG['Põllumaa rent'] || 'Põllumaa rent'} url={"/index.php?f=oksjonid&t=5"}/>
                    </React.Fragment>
                )
            } else if (this.props.page === "post") {
                return (
                    <React.Fragment>
                        <FrontRow auctionType={this.props.auctionType} item={sale} title={LANG['Müün'] || 'Müün'} url={"/index.php?f=kuulutused&type=sale"}/>
                        <FrontRow auctionType={this.props.auctionType} item={rent} title={LANG['Annan rendile'] || 'Annan rendile'} url={"/index.php?f=kuulutused&type=rent"}/>
                    </React.Fragment>
                )
            }


        } else {
            return <Loading/>;
        }
    }
}

export default Front;
